const ApiHelpers = {

	// taken from api_helpers.pub
	prepareApiKey(value) {
		let formattedValue = value.toLowerCase();
		formattedValue = formattedValue.replace(" / ", "_");
		formattedValue = formattedValue.replace(" ", "_");
		formattedValue = formattedValue.replace("-", "_");
		formattedValue = formattedValue.replace("'", "");
		formattedValue = formattedValue.replace("’", "");

		return formattedValue;
	},
};

export default ApiHelpers;



// WEBPACK FOOTER //
// ./src/shared/util/ApiHelpers.js